var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-bar-4",staticStyle:{"transform":"translateX(0px)"},attrs:{"id":"footer-bar"}},[_c('router-link',{attrs:{"to":{name: 'homeyouth'}}},[_c('i',{staticClass:"fa fa-home"}),_c('span',[_vm._v("Эхлэл")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }